export const CERTIFICATIONS =
    [
        {
            id: 1,
            name:'Front-End Web Development with React',
            year:'Issued May 2020',
            organization:'Coursera',
            link: 'https://coursera.org/share/738e081d0cf3fb2701a692af8e5642a4'
        },
        {
            id: 2,
            name:'Modern React with Redux',
            year:'Issued July 2020',
            organization:'Udemy',
            link: 'https://www.udemy.com/certificate/UC-dfcefd09-285e-476d-be38-f4536ea50905'
        },
        {
            id: 3,
            name:'The Complete Web Developer in 2020: Zero to Mastery',
            year:'Issued June 2020',
            organization:'Udemy',
            link: 'https://www.udemy.com/certificate/UC-86f61a79-0c48-4383-ad21-8cabfecfaf68'
        },
        {
            id: 4,
            name:'Front-End JavaScript Frameworks: Angular',
            year:'Issued May 2020',
            organization:'Coursera',
            link: 'https://coursera.org/share/378bbcc956571ba38254b0f0d5b82563'
        }
    ];